<template>
	<div class="item-adres">
		<div class="item-adres-br">
		    <h3>Order Summary</h3>
			<ul>
				<li><strong>Products</strong><span><var>{{ productCount }}</var></span></li>
				<li v-if="percentOffName && percentSavings > 0 && membership >= 1" class="text--blue" style="font-weight:bold"><strong class="memberSavings" style="font-weight:bold">{{ percentOffName }}</strong> <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="minusCurrencySymbolLeft"><var>{{ percentSavings }}</var></span></li>
                                <li v-if="percentOffName && percentRetailSavings > 0 && !membership" class="text--blue" style="font-weight:bold"><strong class="memberSavings" style="font-weight:bold">{{ percentOffName }}</strong> <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="minusCurrencySymbolLeft"><var>{{ percentRetailSavings }}</var></span></li>
				<li v-if="percentOffNameSecond && percentSavingsSecond > 0"><strong>{{ percentOffNameSecond }}</strong> <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>-{{ percentSavingsSecond }}</var></span></li>
            <li v-if="couponAmount>0 && shippingOrderCount > 0" class="text--blue" style="font-weight:bold"><strong class="memberSavings" style="font-weight:bold">${{ couponAmount }} Off from<br>{{ enrollerFirst }}</strong> 
             <span>-<var :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ couponAmount }}</var></span>
            </li>
				<li v-if="retailTotalPrice > 0">
               <strong v-if="retailOnly!=1">Retail Price</strong>
               <strong v-else>Price</strong>
               <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">
                  <var v-if="membership>=1" style="text-decoration:line-through">{{ retailTotalPrice }}</var>
                  <var v-else>{{ retailTotalPrice }}</var>
               </span>
            </li>            
            <li v-if="totalMemberSave > 0 && membership >= 1" class="text--orange"><strong  class="memberSavings">You Save</strong><span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>{{ totalMemberSave }}</var></span></li>
            <li v-if="membership >= 1" class="text--blue"><strong>Member Price</strong> <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>{{ totalPrice }}</var></span></li>
                        </ul>
                        <ul>
                         <li v-if="totalMemberSave > 0 && !membership && retailOnly!=1"> 
                           <div class="text--blue" style="width:50%;float:left;">Would you like to save <b class="text--orange" :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>{{ totalMemberSave }}</var></b> today by becoming a member?</div>
                           <div style="width:45%;float:right;text-align:right">
                            <a class="shoppingCartLiButton" href=# @click="addMembershipToCart">Yes</a>&nbsp;&nbsp;
                            <a class="shoppingCartLiButton" href="/membership">Learn More</a>
                           </div>
                         </li>
                         <li v-if="!isLoggedIn && totalMemberSave > 0 && !membership && retailOnly!=1"><div class="shoppingCartLabelText">Already A Member?</div><span><a class="shoppingCartLiButton" @click="openLoginModal()" href="#">Login To Save</a></span></li>
                         <li v-if="totalMemberSave > 0 && !membership && retailOnly!=1" style="display:none"><div class="shoppingCartLabelText">Join and Save</div><span><a class="shoppingCartLiButton" href="/membership">Learn More</a></span></li>
			</ul>
		</div>
         <login-modal
            :scriptName="scriptName"
            v-if="loginModalOpen"
            @modal-closed="closeLoginModal()"
         >
         </login-modal>

	</div>
</template>

<style>
	.item-adres span[data-currency-symbol-left], .itembar span[data-currency-symbol-right] {
		float: right !important;
	}
   .cart-summary-notice {
      font-family: "Lato","Helvetica Neue","Helvetica",Helvetica,Arial,sans-serif;
      color:red;
      font-size:12px;
      margin-bottom:10px; 
   }
</style>

<script>
    import LoginModal from './LoginModal.vue'
    export default {
        props: {
			totalPrice: String,
			retailTotalPrice: String,
         currencySymbolRight: String,
			currencySymbolLeft: String,
         minusCurrencySymbolLeft: String,
			productCount: Number,
         productFreeCount: Number,
         totalMemberSave: String,
			isLoggedIn: Boolean,
			percentSavings: String,
                        percentRetailSavings: String,
			percentOffName: String,
			percentSavingsSecond: String,
			percentOffNameSecond: String,
         membership: Number,
         scriptName: String,
         coupon: Number,
         couponAmount: String,
         enrollerFirst: String,
         shippingOrderCount: Number,
         retailOnly:Number
		},
        components: {
                'login-modal': LoginModal,
                },
        data: function () {
                        return {
                                loginModalOpen: false
                        }
                },
        methods: {
           addMembershipToCart () {
              shoppingCart.addToCart(1,1).then((x) => {
                  document.getElementById("openCart").click()
               })
            },
            openLoginModal() {
               console.log("opening login modal")
               this.loginModalOpen =true
               console.log(this.loginModalOpen)
            },
            closeLoginModal() {
               console.log("closing login modal")
               this.loginModalOpen= false
            },
        }
    }

</script>

<style>
</style>
